export default __webpack_public_path__ + "static/home-hero-1510b8b403e12f820210495a517f69ce.png";